<template>
  <div>
    <doc-title></doc-title>
    <list resource="posts"></list>
  </div>
</template>

<script>
  import DocTitle from '@/vues/helpers/doc-title.vue';
  import List from './list.vue';

  export default {
    name: 'PostsIndex',
    components: { DocTitle, List }
  };
</script>
